import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { QaiAlertComponent } from '@qai/ui';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  imports: [CommonModule, QaiAlertComponent, TranslocoModule],
  selector: 'app-call-hint',
  standalone: true,
  templateUrl: './call-hint.html',
})
export class CallHintComponent {
  @Input({ required: true }) hint!: string;
  @Input({ required: false }) maxHeight: string = '120px';
}
